import type { FC } from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { CONSULTATION_SEARCH_PARAMS } from '@frontend/components/agromarket/core/routes'
import { addCommentForConsultingForm } from '@/components/composed/InstallmentCalculator/hooks'
import { openModal } from '@/components/composed/Modal/actions'
import { addModalToWellKnown } from '@/components/composed/Modal/constants'
import { LandingConsultingModal } from '@/components/composed/modals'
import type { IFinancingConsultingModalProps } from '@/components/composed/modals/LandingConsultingModal/types'
import { useQueryParams } from '@/pages/OfferRequests/hooks/useQueryParams'

addModalToWellKnown({ LandingConsultingModal })

export const FinancingConsultationPrompt: FC = () => {
  const { search } = useLocation()
  const dispatch = useDispatch()
  const { removeSpecificParams } = useQueryParams()

  useEffect(() => {
    const key: keyof typeof CONSULTATION_SEARCH_PARAMS = 'requestConsultation'
    const consultParam = `${key}=${CONSULTATION_SEARCH_PARAMS.requestConsultation}`

    if (!search.includes(consultParam)) return

    setTimeout(() => {
      dispatch(
        openModal({
          options: {
            dialogId: 'LandingConsultingModal',
            onCloseModal: () => removeSpecificParams(key),
          },

          contentOptions: {
            requestMapper: addCommentForConsultingForm,
          } as IFinancingConsultingModalProps['options'],
        }),
      )
    }, 500)
  }, [search, dispatch, removeSpecificParams])

  return null
}
